import Toastify from "toastify-js";

export function createToast(message = "", type = "info", destination = "") {
	let toastMessage = document.createElement("div");
	let toastMessageInner = document.createElement("span");
	let toastMessageStyle = "md:flex gap-4 bg-none";
	toastMessageInner.innerText = message;
	toastMessage.classList.add("flex", "gap-4");
	toastMessage.appendChild(toastMessageInner);

	if (type === "error") {
		toastMessageStyle += " bg-red";
	} else if (type === "success") {
		toastMessageStyle += " bg-green";
	} else if (type === "info") {
		toastMessageStyle += " bg-secondary";
	} else {
		toastMessageStyle += " bg-secondary";
	}

	Toastify({
		node: toastMessage,
		duration: 5000,
		destination: destination,
		newWindow: false,
		close: true,
		gravity: "bottom", // `top` or `bottom`
		position: "right", // `left`, `center` or `right`
		stopOnFocus: true, // Prevents dismissing of toast on hover
		className: toastMessageStyle,
		style: {
			// background: "#ff9015",
		},
		onClick: function () {}, // Callback after click
	}).showToast();
}
